import { useQuery } from '@hooks/reactQuery';

import { auth } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { getAssetCartRequestCount } from '@api/assetCartRequest';

import { ASSET_CART_REQUEST_COUNT } from '@constants/queryKeys';

export const useQueryAssetCartRequestCount = () => {

	const authState = useAppSelector(auth);

	const {
		accessPermission: { networkOperatorAssetEnquirer, assetConsumerAssetEnquirer },
	} = authState;

	const isEnabled = networkOperatorAssetEnquirer || assetConsumerAssetEnquirer;

	const { data: assetCartRequestCount } = useQuery({
		queryKey: [ASSET_CART_REQUEST_COUNT],
		queryFn: getAssetCartRequestCount,
		refetchOnWindowFocus: false,
		enabled: [isEnabled],
	});

	return {
		assetCartRequestListCount: assetCartRequestCount?.count || 0,
	};
};
